import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { AuthStore } from './auth.store';

/**
 * Guest pages a signed-in user may still open: an email-confirmation link
 * belongs to whichever account registered, which need not be the one signed
 * in on this browser, so it has to be confirmed rather than skipped.
 */
const OPEN_TO_EVERYONE: readonly string[] = ['/login/confirm-email'];

export const guestGuard: CanActivateFn = (_route, state) => {
  const store = inject(AuthStore);
  const router = inject(Router);
  const path = state.url.split(/[?#]/)[0] ?? '';

  if (OPEN_TO_EVERYONE.includes(path)) {
    return true;
  }

  return store.isAuthenticated() ? router.createUrlTree(['/']) : true;
};
